export default {
    data(){
        return {                   
            zipcode_mask: '#####',     
            isValidZipcode: null,
            zipcodeMessage: null,
            //60 miles from 32835. https://www.freemaptools.com/find-zip-codes-inside-radius.htm
            zipcodes_list: [32835,32811,34734,32805,34761,32808,32818,32839,32819,34786,32710,32853,32854,32855,32856,32857,32858,32859,32860,32861,32862,32867,32868,32869,32872,32877,32878,32885,32886,32887,32891,32897,32896,32802,32804,32801,34777,34778,32809,32810,32806,32836,32803,32789,34760,32812,32837,32821,34787,32733,32794,32703,32814,32790,32793,34740,32830,32751,32799,32714,32704,32807,32822,32715,32716,32701,32768,32730,32824,34756,32792,32707,32718,32719,32827,32712,34729,32817,32752,32791,32779,32750,34741,32798,34743,32825,34711,34747,32829,34755,34742,34745,32708,32757,34715,34712,34713,32816,33848,32746,32826,33896,34744,32777,32795,32828,32745,34705,34746,32762,34714,32765,32832,33858,32776,32831,32773,32756,33897,34758,34770,34769,34737,32747,32772,32778,34736,32820,32771,33837,33836,34753,34797,32833,32727,32766,32713,32726,32736,32753,32732,34748,33868,32725,32834,34772,34762,32728,34771,33845,32784,32739,32709,34759,32735,32763,34749,34789,34788,32774,33844,32738,32720,33514,33850,32767,32706,33851,33881,32764,34731,32754,32744,33585,32796,32721,33823,33809,33838,32723,32702,34773,33882,33883,33888,33877,32158,32159,32780,33885,33597,33884,32163,32722,32168,32927,33839,33805,32926,34785,33849,32195,33880,32775,32781,32783,32162,33801,33537,33810,32724,33521,33513,32133,33898,33853,33856,33593,33806,33840,32183,32759,33802,32959,33804,32141,33803,33526,33812,33859,32130,32102,33846,33540,34484,32922,32923,32924,33523,32105,33815,32132,34661,33854,32124,33542,32955,33807,32179,33539,33820,34491,34492,33524,33525,32956,32111,32180,33827,33831,32128,33813,32815,32170,33574,34602,32953,32954,32169,33541,34636,33811,33538,33830,34420,33565,33855,34421,32129,34739,32127,32940,32119,34472,34450,33564,34436,33576,33545,34483,34601,33563,32952,32114,32934,32920,33566,32904,34480,32931,33847,32899,34603,34611,34473,33867,33863,34605,32932,32198,32115,32116,32120,32121,32122,32123,32125,32126,33843,34488,32118,33543,32117,34451,33592,32190,32174,33544,32925,32935,34453,33567,33841,34604,34464,34452,33860,34471,34476,34470,32936,33587,33527,32173,32175,32937,34489,34639,32139,33647,32907,34441]            
        }
    },
    watch:{
        form:{
            deep: true,
            handler(form){
                if(form.zipcode == null || form.zipcode.length < 5){
                    this.isValidZipcode = null
                    this.zipcodeMessage = null
                }
            }
        }
    },
    methods:{
        formatZipcode(e){
            return String(e).substring(0,5);
        },

        verifyZipcode(){
            this.isValidZipcode = null
            this.zipcodeMessage = null

            if(this.form.zipcode != null && this.form.zipcode.length == 5){

                const valid = this.zipcodes_list.includes(parseInt(this.form.zipcode))
                this.zipcodeMessage = !valid ? this.$t('INVALID_ZIPCODE') : this.$t('VALID_ZIPCODE')
                this.isValidZipcode = valid                

            }else{
                this.zipcodeMessage = this.$t('NULL_ZIPCODE')
            }
        }
    }
}